"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Argos = function Argos(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.3638 17.5975C18.0803 17.5975 17.8167 17.5975 17.5556 17.5975C16.1505 17.5975 14.7454 17.5999 13.3403 17.5925C13.1612 17.5925 13.0568 17.6472 12.9673 17.8039C12.5196 18.5773 12.0546 19.3432 11.6044 20.1167C11.4055 20.4599 11.1344 20.6315 10.7241 20.6215C10.0128 20.6041 9.30157 20.619 8.59031 20.6165C8.0606 20.6165 7.87657 20.2783 8.16256 19.8083C9.57015 17.483 10.9653 15.1479 12.4002 12.8375C13.6362 10.848 14.9344 8.89826 16.3544 7.0306C16.904 6.30691 17.5904 6.00599 18.4558 6.00351C19.0527 6.00102 19.6496 5.99855 20.2464 6.00103C20.7687 6.00352 21.0422 6.25717 21.0696 6.7844C21.1318 7.91594 21.1815 9.04499 21.2387 10.1765C21.3382 12.1039 21.4376 14.0337 21.5396 15.9611C21.6117 17.3289 21.6838 18.6967 21.751 20.062C21.7684 20.3977 21.5893 20.6041 21.2536 20.6091C20.5175 20.6215 19.7789 20.619 19.0403 20.6091C18.6772 20.6041 18.5056 20.4151 18.4882 20.0446C18.4534 19.2736 18.421 18.5002 18.3862 17.7293C18.3912 17.6994 18.3788 17.6671 18.3638 17.5975ZM14.3276 15.0136C15.7277 15.0136 17.0682 15.0136 18.436 15.0136C18.3489 13.0837 18.2644 11.1713 18.1773 9.25638C18.15 9.24892 18.1251 9.23898 18.0977 9.23152C16.7299 11.0693 15.5586 13.0365 14.3276 15.0136Z",
    fill: "#DB3E34"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.7174 25.0002C12.3157 24.99 10.161 24.2175 8.20832 22.8078C8.08362 22.716 7.93399 22.6268 8.03125 22.4458C8.1335 22.2546 8.30059 22.3387 8.44773 22.3948C9.18841 22.6752 9.91413 23.0092 10.6723 23.2208C12.7721 23.8071 14.9069 23.8734 17.0566 23.5496C18.4532 23.3406 19.8074 22.9658 21.1266 22.456C21.2414 22.4126 21.3636 22.3617 21.4808 22.3642C21.6526 22.3046 21.8385 22.5788 21.6179 22.7262C21.1566 23.0219 20.6977 23.3278 20.2139 23.5802C18.4906 24.4827 16.6601 24.9721 14.7174 25.0002Z",
    fill: "#DB3E34"
  }));
};

Argos.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Argos.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Argos;
exports.default = _default;